import React, {useEffect, useState} from 'react';
import { CreateLeadFooter, StyledFlexEnd, StyledLeadContainer, StyledSubHeader } from '../../Components/Styled';
import { Box, Button, createFilterOptions,  Stack,  Tooltip, Typography } from '@mui/material';
import { privateRoutesPath } from '../../Routes';
import BiztantuLoader from '../../Components/Loader';
import { useSelector, useDispatch } from 'react-redux';
import { createOrderRequestData, createRequestData,downloadDocument, getOrderRequestData, getRequestData, updateOrderRequestData } from '../../Utility/apiHelper';
import { ACTIVE_STATUS, handleValidateCodevalue,INVOICE_STATUS,INVOICE_STATUS_OPEN, INVOICE_STATUS_SENT, PRODUCT_TYPE, searchEntity } from '../../Utility/constant';
import { useSnackbar } from 'notistack';
import moment from 'moment';
import WhoColumnTextfieds from '../../Components/WhoColumnTextfieds';
import { EntityNote } from '../../Components/EntityNote';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import LeadProduct from '../../Components/LeadProduct';
import TextFiledWithLabel from '../../Components/TextFieldWithLabel';
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable';
import LeadDialog from '../../Components/LeadDialog';
import { requestGetAllCustomers } from '../../Store/Customer/action';
import LeadAccordion from '../../Components/LeadAccordion';
import AuditLogs from '../Configuration/Audit';

import AutoCompleteComponent from '../../Components/AutoCompleteComponenet';
import { requestShowLoader,requestHideLoader, requestShowDialogLoader,requestHideDialogLoader } from '../../Store/Global/action';
import useNavigation from '../../Utility/hooks/useNavigation';
import './invoice.css';
const CreateEditInvoice = (props) => {
    
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const [isDialogOpen, setOpenDialog] = useState({
            isOpen: false,
            dilaogproductdata: []
    });
    
    const [selectionModel, setSelectionModel] = React.useState([]);
    var filterdOptionlist = [];
    const [inputprice, setInputprice] = useState({
        pricefromInput: 0,
        pricetoInput: 100000000
    })
    const [tableData, setTableData] = useState([]);
    const [selectedaddedproduct, setselectedaddedproduct] = useState([]);
    const [selectedproduct, setSelectedproduct] = useState(null);
    const [selectedproductData, setSelectedProductData] = useState(null);
    const location = useLocation()
    const customerdropdown = useSelector(state=>state?.customer?.customer)
   const canEdit = !!specificRolePermission?.isInvoiceManage;
   const [isEntityLocked, setIsEntityLocked] = useState(false);
   const isViewMode = !canEdit || isEntityLocked;
   // Audit Logs accordion — controlled so we can collapse it after actions; fetches lazily on expand
   const [isAuditAccordionExpanded, setIsAuditAccordionExpanded] = useState(false);
    const invoiceId = props.match.params.id;
    const isLoadingProgress = useSelector(state => state?.global.isLoading);
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const [invoicedetail, setinvoicedetail] = useState({
        status : 'INVOICE_STATUS_OPEN',
        ownerId : currentUser?.userId
    })
    const [initialInvoiceDetails,setInitialInvoiceDetails] = useState(null);
    const [invoiceProducts , setInvoiceProducts] = useState([]);
    const dispatch = useDispatch();
    const {enqueueSnackbar} = useSnackbar();
    const productStaticType = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == PRODUCT_TYPE)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const invoiceStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == INVOICE_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);     
    const [productQuantity, setproductQuantity] = useState(null);
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const ownerlist = useSelector(state => state?.owner?.ownerlist);  
    const [ownerlistdropdown, setownerlistdropdown] = useState([]);
    
    const { navigateTo,goBackTo } = useNavigation();
    const [htmlContent,setHtmlContent] = useState(
        {
            html : "",
            viewHtml : false
        }
    )
    const myTeam = useSelector(state => state?.owner?.Team);
    
      useEffect(() => {
                const ownerlistdata = ((specificRolePermission?.isAllInvoiceManage ? ownerlist : 
                specificRolePermission?.isInvoiceTeamManage ? myTeam : [{
                    firstName: `${currentUser?.firstname}`,
                    lastName : `${currentUser?.lastname}`,
                    id: currentUser?.userId,
                }]) || [])?.map(item => {
                    return {
                        name: `${item?.firstName} ${item?.lastName}`,
                        id: item?.id
                    }
                })
                setownerlistdropdown(ownerlistdata);
            },[ownerlist,myTeam,currentUser])
            
    useEffect(() => {
        dispatch(requestGetAllCustomers());
    }, []);

    useEffect(() => {
        if(invoiceId && ownerlistdropdown?.length > 0) {
            handlegetspecificinvoicedetails();
        }
    }, [invoiceId, ownerlistdropdown])


    const goBack = ()=>goBackTo(privateRoutesPath.INVOICE,searchEntity?.invoice);

    // const getCustomerTable = async() => {
    //     const reqUrl = `${process.env.REACT_APP_BASE_URL}customers/`;
    //     const responseData = await getRequestData(reqUrl);
    //     if(responseData?.data) {
    //       const customerdata = responseData?.data;
    //       const tableCustomerData = customerdata.sort((a,b) => new Date(b?.updated) - new Date(a?.updated)).map(item => {
    //         return {
    //           ...item,
    //           id: item?.id,
    //           name : `${item?.firstName} ${item?.lastName}`
    //         }
    //       })
          
    //       setcustomerdropdown(tableCustomerData);
    //     }
    // }

    
    const handlegenerateinvoice = () => {
        const dilaogproduct = invoiceProducts.filter(item => selectionModel.includes(item?.id)).map(item => {
            return {
                ...item,
                price : item?.sellingPrice,
                invoiceqty: item?.remainingQty
            }
        });
        setOpenDialog({
            ...isDialogOpen,
            isOpen: true,
            dilaogproductdata: dilaogproduct
        })
    }
    
    const handleviewproductinvoices = (productId, orderId) => {
        navigateTo(`${privateRoutesPath.INVOICE}`,{productId, orderId },searchEntity?.invoice);
    }
    

        const handleChangeQuantity = (e) => {
            setproductQuantity(e.target.value)
       }
        
        const filter = createFilterOptions();
        const handleFilterOption = (options, params) => {
        filterdOptionlist = filter(options, params);
        return [ { name: 'Select All', price: "", value: "select-all" }, ...filterdOptionlist];
   }

    
     const handleAddInvoiceProduct = async() => {
        const payload = [];
            selectedaddedproduct.map((item, index) => {
            payload.push({...item,
                sGst: item?.sgstRate,
                cGst: item?.cgstRate,
                primaryDiscount: item?.primaryDiscount,
                surchargeRate: item?.surChangeRate,
                "sellingPrice": parseFloat(item?.price),
                "totalPrice": (1*item?.price),
                "invoiceQty": 1,
                "productId": item?.id,
                "invoiceId": parseInt(invoiceId)
            })
        });
                    dispatch(requestShowLoader());
                    const reqUrl = `${process.env.REACT_APP_BASE_URL}invoice-product`
                    const responseData = await createRequestData(payload,reqUrl);
                    if(responseData?.status == 200) {
                        enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_ADDED_SUCCESSFULLY'), { variant: 'success' });
                        setselectedaddedproduct([]);
                        dispatch(requestHideLoader());
                        await handlegetspecificinvoicedetails();
                        setIsAuditAccordionExpanded(false);
                        return true;
                    } else {
                        enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), { variant: 'error' });
                        dispatch(requestHideLoader());
                        return false;
                    }
     }
     const handleUpdateStatus = async(status) => {
      const reqPayload = {
        ...invoicedetail,
        status : status,
        "invoiceProductDto" : []
      }
       selectedaddedproduct.map((item, index) => {
            reqPayload?.invoiceProductDto?.push({
                "productId": item?.id,
                "productQuantity": 1,
                "totalPrice" : item?.price
            })
        });
        const url = `${process.env.REACT_APP_ORDER_URL}invoice/${invoiceId}`;
        const responseData = await updateOrderRequestData(reqPayload,url);
        if(responseData?.status == 200){
          enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_UPDATED_SUCCESSFULLY') , {variant : 'success'})
            await handlegetspecificinvoicedetails();
            setIsAuditAccordionExpanded(false);
        }
        else {
            enqueueSnackbar(handleValidateCodevalue(internationalise,responseData?.propererror?.data?.error || "COMMON_PLEASE_TRY_AGAIN") , {variant : 'error'})
        }
      }

  const handleUpdateOrderproduct = async(orderproduct) => {
    dispatch(requestShowLoader())
        const payload = {
            ...orderproduct,
            "id": orderproduct?.id,
            "invoiceId": orderproduct?.invoiceId,
            "productId": orderproduct?.productId,
            "invoiceQty": orderproduct?.quantity,
            "invoiceQty": parseFloat(orderproduct?.quantity),
            "sellingPrice": orderproduct?.sellingPrice,
        }
        const url = `${process.env.REACT_APP_ORDER_URL}invoice-product/${orderproduct?.invoiceProductId}`;
        const responseData = await updateOrderRequestData(payload,url);
    if(responseData?.status == 200){
          enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_UPDATED_SUCCESSFULLY') , {variant : 'success'})
          await handlegetspecificinvoicedetails();
          setIsAuditAccordionExpanded(false);
        }
        else {
            enqueueSnackbar(handleValidateCodevalue(internationalise,responseData?.propererror?.data?.error || "COMMON_PLEASE_TRY_AGAIN") , {variant : 'error'})
        }
    dispatch(requestHideLoader())
      }    
  

    const handleSelectMultiproduct = (event, productData, reason) => {
            if (productData.find(option => option.value === "select-all")) {
                setselectedaddedproduct([...selectedaddedproduct,...filterdOptionlist]);
            } else {
                setselectedaddedproduct(productData);
            }
        }
    

    const handleChangeInvoiceDetails = (event) => {
        setinvoicedetail({
            ...invoicedetail,
            [event.target.name]: event.target.value
        })
    }

    const handlegetspecificinvoicedetails = async() => {
        const url = `${process.env.REACT_APP_ORDER_URL}invoice/${invoiceId}`;
        const responsedata = await getOrderRequestData(url);
        const productData = responsedata?.data;
        const filteredCustomer = customerdropdown?.find(item=> item?.id === responsedata?.data?.customerId)
        const filteredOwner = ownerlistdropdown?.find(item=> item?.id === responsedata?.data?.ownerId)
        const updatedData = {
                ...responsedata?.data,
                selectedOwner : filteredOwner,
                selectedCustomer : filteredCustomer,
            }
            setinvoicedetail(updatedData);
        setInitialInvoiceDetails(updatedData)
        const invoiceProduct = productData?.invoiceProductDto?.map(item => ({
        ...item,
        unitOfMeasurement : item?.uom,
        invoiceProductId : item?.id,
        id : item?.productId,
        quantity : item?.invoiceQty,
        type : item?.productType,
        name : item?.productName,
        totalPrice : item?.totalPrice,
        unitDiscountAmount : item?.sellingPrice- (item?.sellingPrice - (item?.sellingPrice * item?.primaryDiscount)/100)
        }));
        setInvoiceProducts(invoiceProduct)
        if (!(updatedData?.status === INVOICE_STATUS_OPEN || updatedData?.status === INVOICE_STATUS_SENT)) {
            setIsEntityLocked(true);
        }
        dispatch(requestHideLoader());
        
    }

    const handleClearAfterAdded = () => {
        setselectedaddedproduct([]);
         
    }
    const handleDownloadInvoicePdf = async () => {
      await downloadDocument(invoicedetail?.documentId);
    };

    const handleupdateInvoice = async(value = false) => {
        if(JSON.stringify(invoicedetail) == JSON.stringify(initialInvoiceDetails)){
            if(value == true){
                goBack();
            } else {
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_NO_DATA_CHANGED"), {variant : 'info'});
            }
            return;
        }
      if(invoicedetail?.customerId){
      dispatch(requestShowLoader());
      const reqPayload = {
        ...invoicedetail,
        "invoiceProductDto" : []
      }
        tableData.map((item, index) => {
                reqPayload.invoiceProductDto.push({
                    "productId": item?.id,
                    "invoiceQty": parseFloat(item?.quantity),
                    "totalPrice" : item?.grossprice
                })
            });
        const url = `${process.env.REACT_APP_ORDER_URL}invoice/${invoiceId}`;
        const responseData = await updateOrderRequestData(reqPayload,url);
        if(responseData?.status == 200){
          dispatch(requestHideLoader())
          enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_UPDATED_SUCCESSFULLY') , {variant : 'success'})
          navigateTo(`${privateRoutesPath.EDIT_INVOICE}/${responseData?.data?.id}`,{},searchEntity?.invoice)
          handlegetspecificinvoicedetails();
          setIsAuditAccordionExpanded(false);
          if(value == true){
            goBack();
          }
        }
        else {
            handleClearAfterAdded()
          dispatch(requestHideLoader())
          enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_PLEASE_TRY_AGAIN'),{variant : 'error'})
        }
      }
    else {
      
      dispatch(requestHideLoader())
    }
    handleClearAfterAdded()
    }


    const handlegenerateInvoice = async() => {
        dispatch(requestShowDialogLoader());
          const reqPayload = {
            customerdetails: invoicedetail?.customerDetails ? {
                name: `${invoicedetail?.customerDetails?.firstName}  ${invoicedetail?.customerDetails?.lastName}`, 
                email: invoicedetail?.customerDetails?.email,
                phone: invoicedetail?.customerDetails?.phone
            } : {
                name: "", 
                email: "",
                phone: ""
            },
            invoiceproducts: invoicedetail?.invoiceProductDto?.map((item,index) => { 
                return {...item, 
                    taxPercent: parseInt(item?.taxPercent) || 18, 
                    rate: parseFloat(item?.sellingPrice).toLocaleString('en'),  
                    srno: index + 1, 
                    price: parseFloat(item?.totalPrice).toLocaleString('en'),
                    
                  }
                }),
            costanalysis: {
                taxPercent: parseInt(invoicedetail?.taxPercent) || 18,
                totalInvoicedAmout: parseFloat(invoicedetail?.totalPrice).toLocaleString('en'),
                invoicenumber: invoicedetail?.id,
                invoicedDate: moment(new Date(invoicedetail?.createdAt)).format('MM/DD/YYYY'),
                title: invoicedetail?.remark,
                totalproduct: invoicedetail?.invoiceProductDto?.length,
                description: invoicedetail?.note,
                taxableamount: parseFloat(parseFloat(invoicedetail?.totalPrice)*12/100).toLocaleString('en'),
                cgstamount: parseFloat(parseFloat(invoicedetail?.totalPrice)*9/100).toLocaleString('en'),
                sgstamount: parseFloat(parseFloat(invoicedetail?.totalPrice)*9/100).toLocaleString('en'),
                totalgst: parseFloat(parseFloat(invoicedetail?.totalPrice)*18/100).toLocaleString('en'),
                taxablenetamount: parseFloat(parseFloat(invoicedetail?.totalPrice) + parseFloat(parseFloat(invoicedetail?.totalPrice)*18/100)).toLocaleString('en')
            }
          }

          const url = `${process.env.REACT_APP_NODE_BASE_URL}/genrate-invoice`;
  
          const responseData = await createOrderRequestData(reqPayload, url, false);
  
          if(responseData?.status == 200) {

            await handlegetspecificinvoicedetails();

            setIsAuditAccordionExpanded(false);
            enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_CREATED_SUCCESSFULLY'), {variant: 'success'})
            handleCancelPreview();
                
          }
          else{
            const errorCode = responseData?.propererror?.data?.message || 'COMMON_PLEASE_TRY_AGAIN';
            enqueueSnackbar(handleValidateCodevalue(internationalise, errorCode), {variant: 'error'})
            handleCancelPreview();
          }
          dispatch(requestHideDialogLoader());
    }

    const handlePreviewPdf = async () =>{
        dispatch(requestShowLoader())
    const reqUrl = `${process.env.REACT_APP_BASE_URL}invoice/preview/${invoiceId}`
    const response = await getRequestData(reqUrl);
        setHtmlContent((prev)=>({
            html : response?.data,
            viewHtml : true,
        }))
        dispatch(requestHideLoader())
    }

    const handleCancelPreview = ()=>{
        setHtmlContent({
            viewHtml:false
        })
    }

    const handlesendinvoice = async ()=>{
    dispatch(requestShowLoader())
    const reqUrl = `${process.env.REACT_APP_BASE_URL}invoice/resend-email/${invoiceId}`;
    const response = await createOrderRequestData(invoiceId,reqUrl);
    if(response.status === 200){
        enqueueSnackbar(handleValidateCodevalue(internationalise,"INV_EMAIL_SENT_SUCCESSFULLY"),{variant:"success"})
    }
    else{
        const errorCode = response?.propererror?.data?.message || "COMMON_PLEASE_TRY_AGAIN";
        enqueueSnackbar(handleValidateCodevalue(internationalise, errorCode),{variant:"error"})
    }
    dispatch(requestHideLoader())
    }
    
        const handleAuditAccordionChange = (_, isExpanded) => {
            setIsAuditAccordionExpanded(isExpanded);
        };
        
    const handleSelectOwner=(event, Owner)=>{
        setinvoicedetail({
            ...invoicedetail,
            selectedOwner : Owner,
            ownerId : Owner?.id
        })
    }
    const handleSelectCustomer=(event, Customer)=>{
        setinvoicedetail({
            ...invoicedetail,
            selectedCustomer : Customer,
            customerId : Customer?.id
        })
    }
    
const invoiceFormContent = (
    <>
        <StyledLeadContainer>
            <TextFiledWithLabel
                name="invoiceId"
                label={handleValidateCodevalue(internationalise,'INV_EDIT_INV_ID')}
                disabled= {true}
                value={invoiceId}
                InputLabelProps={{
                    shrink: true,
                }}
            />
            {invoicedetail?.orderId &&
                <TextFiledWithLabel
                name="orderId"
                value = {invoicedetail?.orderId}
                label={handleValidateCodevalue(internationalise,'INV_EDIT_ORD_ID')}
                disabled= {true}
            />
            }
            <AutoCompleteComponent
                optionSet = {ownerlistdropdown}
                value={invoicedetail?.selectedOwner|| null}
                name = "ownerId"
                placeholder={handleValidateCodevalue(internationalise,'INV_EDIT_OWNER')}
                disabled = {isViewMode || !(specificRolePermission?.isAllInvoiceManage || specificRolePermission?.isInvoiceTeamManage)}
                label={handleValidateCodevalue(internationalise,'INV_EDIT_OWNER')}
                onChange={(event, Owner) => handleSelectOwner(event, Owner)}
            />
             <SelectBoxWithLabel
                ownerdropdown = {false}
                name="status"
                label={handleValidateCodevalue(internationalise,'INV_EDIT_STATUS')}
                disabled= {isViewMode}
                value={invoicedetail?.status}
                isStatic={false}
                optionMenuItem={invoiceStatusData}
                handleOnChange={handleChangeInvoiceDetails}
            />
            {!invoicedetail?.orderId &&
            <TextFiledWithLabel
            className="invoice-hidden-field"
            />
            }
            </StyledLeadContainer>
            <StyledLeadContainer>
            <AutoCompleteComponent
                isOwner = {true}
                disabled={isViewMode }                       
                optionSet = {customerdropdown}
                value={invoicedetail?.selectedCustomer|| null}
                name = "selectedCustomer"
                placeholder={handleValidateCodevalue(internationalise,'INV_EDIT_CUSTOMER')}
                label={handleValidateCodevalue(internationalise,'INV_EDIT_CUSTOMER')}
                onChange={(event, Customer) => handleSelectCustomer(event, Customer)}
            />
            <TextFiledWithLabel
                name="amount"
                label= {handleValidateCodevalue(internationalise,'INV_EDIT_TOTAL_AMT')}//"Invoice Amount (INR)"
                disabled= {true}
                value={Number(invoicedetail?.totalPrice).toLocaleString('en') || ''}
                handleOnChange={handleChangeInvoiceDetails}
            />
            <TextFiledWithLabel
            className="invoice-hidden-field"
            />
            <TextFiledWithLabel
            className="invoice-hidden-field"
            />
        </StyledLeadContainer>
        <WhoColumnTextfieds
        entityDetails={invoicedetail}
        />
            <EntityNote
            entityDetails = {invoicedetail} 
            onChange = {handleChangeInvoiceDetails}        
            headingLabel = {handleValidateCodevalue(internationalise,"COMMON_SPECIAL_NOTE")}
            />
    </>
);

    return (
        <BiztantuLoader open={isLoadingProgress} isChildren={true}>
            <Box className='globalBox'>
                {invoiceId ? (
                    <LeadAccordion
                        label={`${handleValidateCodevalue(internationalise,'INV_DETAILS')} - ${invoiceId}`}
                        defaultExpanded={true}
                    >
                        
                    {!isViewMode && 
                    <Box className = "mt-15 mb-10">
                    <Button variant="outlined" className='edit-primary' onClick={handleupdateInvoice} >{handleValidateCodevalue(internationalise,'COMMON_SAVE')}</Button>
                    <Button variant="outlined" className='edit-primary btn-space' onClick={()=>handleupdateInvoice(true)} >{handleValidateCodevalue(internationalise,'COMMON_SAVE_AND_EXIT')}</Button>
                    </Box>
                    }
                        {invoiceFormContent}
                    </LeadAccordion>
                ) : (
                    <>
                        <StyledSubHeader>
                            {handleValidateCodevalue(internationalise,'INV_DETAILS')}
                        </StyledSubHeader>
                        {invoiceFormContent}
                    </>
                )}
                {/* <StyledLeadContainer>
                    <DataGridTable 
                        columns ={productTableColumn}
                        dataGridData = {invoiceProducts || []}
                        isRequiredToolBar={false}
                        isCheckboxReq = {false}
                    />
                </StyledLeadContainer> */}
                <LeadProduct
                                    isInvoice = {true}
                                    isEdit={true}
                                    isViewMode = {(isViewMode || invoicedetail?.currentStatus === INVOICE_STATUS_SENT)}
                                    productTypes={productStaticType}
                                    data={invoiceProducts}
                                    getProductDetails={()=>handlegetspecificinvoicedetails(invoiceId)}
                                    selectedproductData={selectedproductData}
                                    isOrderproduct= {false}
                                    selectedproduct={selectedproduct}
                                    selectedaddedproduct={selectedaddedproduct}
                                    productQuantity={productQuantity}
                                    handleChangeQuantity={handleChangeQuantity}
                                    getDataGridData={(data) => setTableData(data)}
                                    handleAddLeadProduct={handleAddInvoiceProduct}
                                    handleUpdateLeadproduct={handleUpdateOrderproduct}
                                    handleSelectMultiproduct={handleSelectMultiproduct}
                                    handleFilterOption={handleFilterOption}
                                    inputprice={inputprice}
                                    invoiceStatus = {invoicedetail?.status}
                                    handleClearAfterAdded={handleClearAfterAdded}
                                    handlegenerateinvoice = {handlegenerateinvoice}
                                    setSelectionModel={(data) => setSelectionModel(data)}
                                    selectionModel={selectionModel}
                                    handleviewinvoices={handleviewproductinvoices} 
                                    accordionLabel = {handleValidateCodevalue(internationalise,'INV_PROD_DETAILS')}
                                
                                />


                    {(specificRolePermission?.isAuditView  && invoiceId) && <div>
                        <LeadAccordion
                            label={handleValidateCodevalue(internationalise,'COMMON_AUDIT_LOGS')}
                            expanded={isAuditAccordionExpanded}
                            onChange={handleAuditAccordionChange}
                            TransitionProps={{ unmountOnExit: true }}
                        >
                            <AuditLogs
                                label = ""
                                isSearchRequired = {false}
                                entityDetails = {{
                                    entityId: invoiceId,
                                    entity: "INVOICE_SIDEBAR_MENU"
                                }}
                                module="Invoice"
                            />
                        </LeadAccordion>
                        
                    </div>}
            

            </Box>
            
                    {htmlContent?.viewHtml &&
                    // <HtmlViewer
                    //  open={htmlContent?.viewHtml}
                    //  htmlContent={htmlContent?.html}
                    //  handleDownload={handlegenerateInvoice}
                    //  handleCancel={handleCancelPreview}
                    // />
                    
                        <LeadDialog
                                open = {htmlContent?.viewHtml}
                                handleClose = {handleCancelPreview}
                                // title= {handleValidateCodevalue(internationalise,"INVOICE")}
                                size = "lg"
                                // "xs" → extra-small (360px max width)
                                // "sm" → small (600px)
                                // "md" → medium (960px)
                                // "lg" → large (1280px)
                                // "xl" → extra-large (1920px)
                                // false → disables the max-width restriction (lets you set custom width with PaperProps)
                                btnlabel={handleValidateCodevalue(internationalise,'INV_GEN_AND_SEND')}
                                alternateBtnLabel = {handleValidateCodevalue(internationalise,'COMMON_CANCEL')}
                                handleSave={handlegenerateInvoice}
                            >
                            <Box dangerouslySetInnerHTML={{ __html: htmlContent?.html }}></Box>
                            </LeadDialog>
                    }
            <CreateLeadFooter>
                <Stack alignItems="center" display={"flex"} justifyContent={"space-between"} flexDirection={"row"}>
                
                    <Typography variant='h6'>
                        {invoiceId ? `${handleValidateCodevalue(internationalise, 'INV_EDIT_TITLE_EDIT')} - ${invoiceId}` : handleValidateCodevalue(internationalise, 'INV_EDIT_TITLE_EDIT')}
                    </Typography>
                
                    <Button className='edit-primary btn-space' variant="outlined" onClick={goBack}>{handleValidateCodevalue(internationalise,'COMMON_BACK')}</Button>
                     {/* {
                    (specificRolePermission?.isInvoiceManage && ((invoicedetail?.status === INVOICE_STATUS_OPEN) || (invoicedetail?.status === INVOICE_STATUS_SENT)) && isViewMode) && <Button className='edit-primary' variant="outlined" onClick={()=>setIsViewMode(!isViewMode)}>{handleValidateCodevalue(internationalise,"COMMON_EDIT")} </Button>
                      } */}
                </Stack>
                <Stack>
                    <StyledFlexEnd>
                       {(!isViewMode && invoiceId && invoicedetail?.documentId) && <>
                       <Tooltip title={handleValidateCodevalue(internationalise,"INV_EDIT_RESEND_EMAIL")}>
                           <Button className='secondry-edit-btn' variant='outlined' onClick={handlesendinvoice}>{handleValidateCodevalue(internationalise,'INV_EDIT_RESEND_EMAIL')}</Button>
                        </Tooltip>
                        <Tooltip title={handleValidateCodevalue(internationalise,"INV_EDIT_DOWNLOAD_INV")}>
                           <Button className='secondry-edit-btn btn-space' variant='outlined' onClick={handleDownloadInvoicePdf}>{handleValidateCodevalue(internationalise,'INV_EDIT_DOWNLOAD_INV')}</Button>
                        </Tooltip>
                        </>}
                    {
                        (!isViewMode && invoiceId && !invoicedetail?.documentId &&((invoicedetail?.status === INVOICE_STATUS_OPEN) || (invoicedetail?.status === INVOICE_STATUS_SENT)))
                    &&
                    <Tooltip title={handleValidateCodevalue(internationalise,"INV_EDIT_PREVIEW")}>
                        <Button className='secondry-edit-btn btn-space' variant='outlined' onClick={handlePreviewPdf}>{handleValidateCodevalue(internationalise,'INV_EDIT_PREVIEW')}</Button>
                    </Tooltip>
                    }
                </StyledFlexEnd>
                
                </Stack>
            </CreateLeadFooter>
             
        </BiztantuLoader>
    )
}

export default CreateEditInvoice;

